/* @flow */
import API from 'lib/RemindAPI';
import { ActionTypes, AllClassesUnreadsKey } from 'constants/UnreadConstants';
import { dispatcher } from 'lib/Dispatcher';

const UnreadActions = {
  async loadUnreads(): Promise<void> {
    const response = await API.request('/notifications/unread', 'GET');
    const { unreads, group_unreads: groupUnreads, organization_unreads: orgUnreads } = response;
    const chatUnreads = unreads.find(u => u.id === 'chats');
    const chatUnreadCount = chatUnreads ? chatUnreads.unread_count : 0;
    const orgUnreadCount = orgUnreads
      ? orgUnreads.map(u => u.unread_count).reduce((a, b) => a + b, 0)
      : 0;
    const allClassesUnreads = {
      id: AllClassesUnreadsKey,
      parent: '',
      unread_count: chatUnreadCount - orgUnreadCount,
    };
    dispatcher.dispatch({
      type: ActionTypes.LIST_UNREADS,
      unreads: unreads.concat(groupUnreads || [], orgUnreads || [], allClassesUnreads),
    });
  },
  async clearThreadUnreads(threadUuid: string): Promise<void> {
    await API.request(`/notifications/threads/${threadUuid}`, 'DELETE');
    dispatcher.dispatch({
      type: ActionTypes.CLEAR_THREAD_UNREADS,
      threadUuid,
    });
  },
};

export default UnreadActions;
